import React from 'react';
import Locale from '../domain/Locale';
import StdCustomPayment from './StdCustomPayment';
import { t, props } from 'tcomb-react';

@props({
  locale: Locale,
  customPayments: t.maybe(t.Arr)
})
export default class ProductCustomPayments extends React.Component {

  getCustomPayment(image, description, index) {
    return (<StdCustomPayment key={index} description={description} image={image} />);
  }

  getCustomPayments() {
    return this.props.customPayments.map((customPayment, index) => {
      return this.getCustomPayment(customPayment.image, customPayment.description, index);
    });
  }
  render() {
    if (!this.props.customPayments) {
      return null;
    }
    return (<div>{this.getCustomPayments()}</div>);
  }
}




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/ProductCustomPayments.js
 **/